import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../helpers/utility';

const initialState = {
  comments: {},
  error: null,
  loading: false,
};

const leadCommentStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const leadCommentSuccess = (state, action) => {
  return updateObject(state, {
    comments: action.comments,
    loading: false,
  });
};

const leadCommentFail = (state, action) => {
  return updateObject(state, { error: action.error, loading: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LEAD_COMMENT_START:
      return leadCommentStart(state, action);
    case actionTypes.LEAD_COMMENT_SUCCESS:
      return leadCommentSuccess(state, action);
    case actionTypes.LEAD_COMMENT_FAIL:
      return leadCommentFail(state, action);
    default:
      return state;
  }
};

export default reducer;